import React from "react";
import Home from "./pages/Home";
import "./App.css";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles

AOS.init({
  duration: 1000 // Duration of animations in milliseconds
  // other options
});

function App() {
  return <Home />;
}

export default App;
